import styled from "styled-components";
import { ModalContainer } from "../../components/Modal/styled";

export const CertificatesModalWrapper = styled.div`
  ${(props) =>
    !props?.isGenerating &&
    `${ModalContainer} {
    max-width: 1220px;
  }`}
`;
